import MSaveProfileButton from './MSaveProfileButton.vue';

export { MSaveProfileButton };
export default MSaveProfileButton;
